/*
 * Copyright (c) 2018 Infowijs.
 * Created by Thomas Schoffelen.
 */

window.widgetParentUrl = ''
window.widgetTimeout = null

function widgetSendMessage (msg) {
  XD.postMessage(msg, window.widgetParentUrl, window.parent)
}

function widgetResetSize () {
  const vertical = $('.widget-search-button').hasClass('has-title') ? 152 : 112
  widgetSendMessage('dimensions:112px,' + vertical + 'px')
}

function toggleWidgetSearch () {
  if (window.widgetTimeout) {
    clearTimeout(window.widgetTimeout)
    window.widgetTimeout = null
  }

  const $body = $('body')
  const shouldOpen = !$body.hasClass('open')
  $body.toggleClass('open')
  if (shouldOpen) {
    $('.search-input').focus()
    widgetSendMessage('dimensions:560px,448px')
  } else {
    window.widgetTimeout = setTimeout(widgetResetSize, 500)
  }
}

function initWidget () {
  $('.widget-search-button').click(toggleWidgetSearch)
  const urlPart = window.location.href.substring(window.location.href.lastIndexOf('#http') + 1)
  try {
    window.widgetParentUrl = decodeURIComponent(urlPart)
  } catch (e) {
    (console.error || alert)('Invalid config URL: ' + urlPart)
    return
  }
  widgetSendMessage('loaded')
  widgetResetSize()

  const originIndex = window.widgetParentUrl.indexOf('/', 8)
  const originUrl = window.widgetParentUrl.substring(0, originIndex)
  XD.receiveMessage(function (message) {
    let data = null
    let command = message.data
    if (!command || !command.length) {
      return
    }
    const colonIndex = command && typeof command === 'string' && command.indexOf(':')
    if (colonIndex > 0) {
      data = command.substring(colonIndex + 1)
      command = command.substring(0, colonIndex)
    }

    const $body = $('body')
    const $input = $('.search-input')

    switch (command) {
      case 'show':
        $body.addClass('open')
        $input.focus()
        widgetSendMessage('dimensions:560px,448px')
        break
      case 'hide':
        $body.removeClass('open')
        $input.blur()
        window.widgetTimeout = setTimeout(widgetResetSize, 500)
        break
      case 'toggle':
        toggleWidgetSearch()
        break
      case 'search':
        $body.addClass('open')
        $input.val(data).keyup().change()
        widgetSendMessage('dimensions:560px,448px')
        searchWidget.helper.setQuery(data)
        searchWidget.helper.search()
        break
      default:
        console && console.warn('[schoolwiki] Unknown command called:', command)
    }
  }, originUrl)
}

if ($('html').hasClass('widget')) {
  $(document).ready(initWidget)
}
